import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .container {
    display: flex;
    align-items: flex-start;
    gap: var(--sds-size-space-400);
    min-height: 42px;
    padding: 0 var(--sds-size-space-400);
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-size-radius-200);
  }

  /* Single line state: center everything */
  .container.single-line {
    align-items: center;
  }

  .avatar {
    width: var(--sds-size-icon-small);
    height: var(--sds-size-icon-small);
    border-radius: var(--sds-size-radius-full);
    object-fit: cover;
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: var(--sds-size-space-100);
  }

  /* When single line, avatar centers */
  .container.single-line .avatar {
    align-self: center;
    margin-top: 0;
  }

  .message-input {
    flex: 1;
    min-width: 0;
    border: none;
    background: transparent;
    color: var(--sds-color-text-default-default);
    font-size: var(--sds-typography-body-size-medium);
    font-family: var(--sds-typography-family-body);
    line-height: 1.4;
    resize: none;
    outline: none;
    padding: var(--sds-size-space-300) 0;
    margin: 0;
    min-height: var(--sds-size-icon-small);
    max-height: 120px;
    overflow-y: auto;
  }

  .message-input::placeholder {
    color: var(--sds-color-text-default-tertiary);
  }

  .message-input:disabled {
    opacity: 0.5;
  }

  .button-group {
    display: flex;
    gap: var(--sds-size-space-150);
    flex-shrink: 0;
    align-self: flex-end;
    padding: var(--sds-size-space-200) 0;
  }

  /* When single line, buttons center */
  .container.single-line .button-group {
    align-self: center;
  }

  .emoji-button,
  .send-button {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: var(--sds-color-icon-default-secondary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: var(--sds-size-radius-full);
    transition:
      color 0.2s ease,
      background 0.2s ease;
  }

  .emoji-button:hover,
  .send-button:not(:disabled):hover {
    color: var(--sds-color-icon-default-default);
    background: var(--sds-color-background-default-secondary);
  }

  .send-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  /* Mobile adjustments */
  @media (max-width: 768px) {
    .container {
      gap: var(--sds-size-space-300);
    }

    .avatar {
      width: 22px;
      height: 22px;
    }

    .message-input {
      font-size: 16px; /* Prevents iOS Safari auto-zoom on focus */
    }

    .emoji-button,
    .send-button {
      width: 26px;
      height: 26px;
    }
  }

  /* Landscape mobile: more compact */
  @media (max-height: 500px) and (orientation: landscape) {
    .container {
      min-height: 36px;
      gap: var(--sds-size-space-200);
      padding: 0 var(--sds-size-space-300);
    }

    .avatar {
      width: 20px;
      height: 20px;
    }

    .message-input {
      font-size: var(--sds-typography-body-size-medium);
      min-height: 20px;
      max-height: 80px;
      padding: var(--sds-size-space-200) 0;
    }

    .button-group {
      padding: var(--sds-size-space-150) 0;
    }

    .emoji-button,
    .send-button {
      width: var(--sds-size-icon-small);
      height: var(--sds-size-icon-small);
    }
  }

  .char-counter {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    text-align: right;
    padding: 0 var(--sds-size-space-400);
  }

  .char-counter.over-limit {
    color: var(--sds-color-text-danger-default, #e53e3e);
  }

  .notify-toggle {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-200);
    padding: 0 var(--sds-size-space-400);
    cursor: pointer;
    user-select: none;
  }

  .notify-toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: var(--sds-color-icon-default-default);
    flex-shrink: 0;
  }

  .notify-label {
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    line-height: 1.4;
  }
`;
